class HomeBestsellers extends HTMLElement {
  connectedCallback() {
    var _a;
    (_a = this.events) == null ? void 0 : _a.abort();
    this.cancelAnimations();
    this.events = new AbortController();
    const { signal } = this.events;
    this.addEventListener("click", (event) => {
      const tab = event.target.closest("[data-bestseller-tab]");
      if (tab && this.contains(tab)) this.select(tab);
    }, { signal });
    this.addEventListener("keydown", (event) => {
      const tab = event.target.closest("[data-bestseller-tab]");
      if (!tab) return;
      const tabs = [...this.querySelectorAll("[data-bestseller-tab]")];
      const index = tabs.indexOf(tab);
      let nextIndex;
      switch (event.key) {
        case "ArrowRight":
          nextIndex = (index + 1) % tabs.length;
          break;
        case "ArrowLeft":
          nextIndex = (index - 1 + tabs.length) % tabs.length;
          break;
        case "Home":
          nextIndex = 0;
          break;
        case "End":
          nextIndex = tabs.length - 1;
          break;
        default:
          return;
      }
      event.preventDefault();
      this.select(tabs[nextIndex], true);
    }, { signal });
    document.addEventListener("shopify:block:select", (event) => {
      var _a2;
      if (!this.contains(event.target)) return;
      const blockId = (_a2 = event.detail) == null ? void 0 : _a2.blockId;
      const tab = [...this.querySelectorAll("[data-bestseller-tab]")].find((button) => button.dataset.blockId === blockId);
      if (tab) this.select(tab);
    }, { signal });
  }
  disconnectedCallback() {
    var _a;
    (_a = this.events) == null ? void 0 : _a.abort();
    this.cancelAnimations();
  }
  cancelAnimations() {
    var _a;
    (_a = this.panelAnimation) == null ? void 0 : _a.cancel();
    this.panelAnimation = null;
  }
  select(activeTab, focus = false) {
    if (activeTab.getAttribute("aria-selected") === "true") {
      if (focus) activeTab.focus();
      return;
    }
    this.cancelAnimations();
    const panelId = activeTab.getAttribute("aria-controls");
    this.querySelectorAll("[data-bestseller-tab]").forEach((tab) => {
      const selected = tab === activeTab;
      tab.setAttribute("aria-selected", String(selected));
      tab.tabIndex = selected ? 0 : -1;
    });
    this.querySelectorAll("[data-bestseller-panel]").forEach((panel) => {
      const selected = panel.id === panelId;
      panel.inert = !selected;
      panel.tabIndex = selected ? 0 : -1;
      panel.setAttribute("aria-hidden", String(!selected));
      panel.classList.toggle("invisible", !selected);
      panel.classList.toggle("pointer-events-none", !selected);
    });
    const activePanel = [...this.querySelectorAll("[data-bestseller-panel]")].find((panel) => panel.id === panelId);
    if (activePanel && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      const timing = { duration: 240, easing: "cubic-bezier(0.22, 1, 0.36, 1)" };
      this.panelAnimation = activePanel.animate([
        { opacity: 0, transform: "translateY(6px)" },
        { opacity: 1, transform: "translateY(0)" }
      ], timing);
    }
    if (focus) activeTab.focus();
  }
}
if (!customElements.get("home-bestsellers")) {
  customElements.define("home-bestsellers", HomeBestsellers);
}
